// src/utils.js
export function formatDate(date) {
  if (date === null || date === undefined || date === "") return null;
  const d = new Date(date);
  if (isNaN(d.getTime())) return null;

  const yyyy = d.getFullYear();
  const mm   = String(d.getMonth() + 1).padStart(2, '0');
  const dd   = String(d.getDate()       ).padStart(2, '0');

  return `${yyyy}-${mm}-${dd}`;
}
